import React from "react";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import Whychooseus from "../../Components/internal-pages/WhyChooseus";
import ClinetsLogoSlider from "../../Components/home/ClientsLogoSlider";
import { Helmet } from "react-helmet";

const Newyearcatalog =()=>{

    const CTAContent = [
        {
          pageName: "New-Year Catalog",
          paragraphitalic: "",
          paragraphText:
            " Celebrate the New Year with meaningful corporate gifts that leave a lasting impression! Our thoughtfully curated collection features elegant hampers, personalized accessories, and premium gift sets, perfect for expressing gratitude and strengthening business relationships. Whether for clients, partners, or employees, these exquisite gifts reflect appreciation and professionalism, setting the tone for a successful year ahead. ",
          ContactFormName: "New Year Catalog",
        },
      ];
    return(
        <>
         <Helmet>
            <title>eYantra New Year Corporate Gifting</title>
            <meta name="description" content="Explore eYantra’s New Year catalog featuring corporate gifts, joining kits, onboarding kits, and company merchandise across Hyderabad."/>
            <meta name="keywords" content="eyantra, New year catalog, corporate gifting, joining kits, rewards and recognitions, onboarding kits for employees, corporate gifts for employees, welcome kits,company merchandise, corporate gifts in hyderabad"/>
        </Helmet>
            <Ctapage data={CTAContent} />
            <ClinetsLogoSlider/>
           <Whychooseus/>
        </> 
    )
}

export default Newyearcatalog;